import { render, staticRenderFns } from "./kdbktv.vue?vue&type=template&id=7b21f11e&"
import script from "./kdbktv.vue?vue&type=script&lang=js&"
export * from "./kdbktv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports